import formatName from 'I18n/utils/formatName';
export const isErroredRoutingUser = ({
  userInPortal,
  canViewInbox,
  routable
}) => {
  return !canViewInbox || !userInPortal || !routable;
};
export const convertUserToOption = user => ({
  avatar: null,
  canViewInbox: user.canViewInbox,
  disabled: !user.routable,
  email: user.email,
  hidden: user.hidden || !user.userInPortal || !user.canViewInbox,
  isFreeUser: !user.routable,
  routable: user.routable,
  tagUse: isErroredRoutingUser(user) ? 'error' : 'default',
  text: formatName(user),
  userInPortal: user.userInPortal,
  value: user.id
});
export const usersToOptions = users => users.map(user => convertUserToOption(user));